/**
 * @generated SignedSource<<8dd77f67af8a3adbdd826c353eeb7f1e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type CheckoutGifting_item$data = {
  readonly vertical: VerticalType | null;
  readonly " $fragmentType": "CheckoutGifting_item";
};
export type CheckoutGifting_item$key = {
  readonly " $data"?: CheckoutGifting_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutGifting_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutGifting_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vertical",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "b7aa7e8a28bd87c33f3dbd99d5636513";

export default node;
